import parser from "./Parser"
// ADD news LINKS  HERE

const enviromentsLibrary = {
  qa: {
    login: "https://accounts.qa.errepar.com/?appCode=CGI",
    base: "https://qa.miestudio.ar/syserrepar",
    e_auth_url_JOB:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/auth/job/getJobCredentialsEAuth",
    e_auth_generate_jwt3:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/eauth/auth/generateJwt3",
    e_auth_notify_user_CAC:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/eAuth/authCAC/notifyLoginUserEAuthCAC",
    e_auth_get_user_CAC:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/auth/getUserCAC/verifyUserCognito",
    e_auth_redirect_auth:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/auth/redirectAuth",
    e_auth_set_password:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api/eAuth/setPassword",
    organization:
      "/businessservices/organization/organization-services/api/organization",
    storage:
      "https://qa.miestudio.ar/syserrepar/businessservices/documentmanager/bulkstorage/bulk-storage-services",
    fileExtend: "/bussinnessservices/security/file-extension-api",
    suborganizations:
      "/bussinnessservices/security/suborganization-api/api/suborganization",
    e_authz: "/integration/authenticationandauthorization/e-authz-api/api",
    customers_and_products_api:
      "/business-services/crm/customers-and-products-api",
    login_account: "/login/api",
    user_legacy_api: "https://accounts.qa.errepar.com/user-legacy-api",
    eventslog_push:
      "https://accounts.qa.errepar.com/eventslog-push/api/eventsLogPush/pushProcessLogEventLogger",
    suscribers:
      "https://accounts.qa.errepar.com/business-services/crm/customers-and-subscribers-api",
    e_auth:
      "https://accounts.qa.errepar.com/syserrepar/integration/authenticationandauthorization/e-authn-api",
    e_auth_client_id: "5ohpn8qif603mg21pfl6mnqf9a",
    invite_api: "/invite-api/api/invite",
    miestudio_user_registration:
      "https://qa.miestudio.ar/syserrepar/business-services/erp/commercialproducts/miestudio-user-registration-api/api",
    subscribers:
      "https://accounts.qa.errepar.com/syserrepar/business-services/crm/customers-and-subscribers-api/api",
    sessions: "https://accounts.dev.errepar.com/sessions/api/esession",
    me: "https://sueldos.dev.miestudio.ar",
  },
  dev: {
    login: "https://accounts.dev.errepar.com/?appCode=CGI",
    localLogin:
      "https://accounts.dev.errepar.com/?urlRedirect=https://localhost:3000&appCode=CGI",
    base: "https://dev.",
    e_auth_url_JOB:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/auth/job/getJobCredentialsEAuth",
    e_auth_generate_jwt3:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/eauth/auth/generateJwt3",
    e_auth_notify_user_CAC:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/eAuth/authCAC/notifyLoginUserEAuthCAC",
    e_auth_get_user_CAC:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/auth/getUserCAC/verifyUserCognito",
    e_auth_redirect_auth:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/auth/redirectAuth",
    e_auth_set_password:
      "https://dev.e-authn-api.miestudio.dev.errepar.com/eAuth/setPassword",
    organization: "organization-api.miestudio.dev.errepar.com/api/organization",
    storage: "https://dev.storage-api.miestudio.dev.errepar.com/api/storage",
    fileExtend: "file-extension.miestudio.dev.errepar.com/api/fileExtension",
    suborganizations:
      "https://api.dev.errepar.com/syserrepar/suborganization/api/suborganization",
    e_authz: "e-authz-api.miestudio.dev.errepar.com/api",
    login_account:
      "https://dev.suscribers-login-module.miestudio.dev.errepar.com/api",
    user_legacy_api: "https://accounts.dev.errepar.com/user-legacy-api",
    customers_and_products_api:
      "https://dev.cust-prod-api.miestudio.dev.errepar.com",
    eventslog_push:
      "https://dev.eventslog-push-api.miestudio.dev.errepar.com/api/eventsLogPush",
    suscribers: "suscribers-api.miestudio.dev.errepar.com",
    e_auth_client_id: "5q4jj9sqi8mhsv7uskuv3j70n0",
    miestudio_user_registration:
      "https://dev.user-registration-api.miestudio.dev.errepar.com/api",
    invite_api: "/invite-api/api/invite",
    e_auth: "/eauth/eAuth",
    subscribers: "https://accounts.dev.errepar.com/subscribers-api/api",
    global_notification:
      "https://dev.global-notification-api.miestudio.dev.errepar.com/api/globalnotification",
    version_enviroments:
      "https://api.dev.errepar.com/syserrepar/rtenvironments/api",
    sessions: "https://accounts.dev.errepar.com/sessions/api/esession",
    declarations:
      "https://api.dev.errepar.com/syserrepar/entitylegaldeclarations/api/entityLegalDeclarations",
    legal_communications: "https://api.dev.errepar.com/legalcommunications/v1",
    logout: "https://accounts.dev.errepar.com/?logout=1&v=1",
    firmsCustomers:
      "https://api.dev.errepar.com/syserrepar/firmscustomers/api/firmscustomers/",
    me: "https://sueldos.dev.miestudio.ar",
    afip_api: "https://api.dev.errepar.com/syserrepar/afip/api",
    xslComposer:
      'https://api.dev.errepar.com/syserrepar/xlscomposerapi/api'
  },
  prod: {
    login: "https://accounts.errepar.com/?appCode=CGI",
    localLogin:
      "https://accounts.errepar.com/?urlRedirect=https://localhost:3000&appCode=CGI",
    base: "https://accounts.errepar.com",
    organization: "/organization-api/api/organization",
    login_account: "https://accounts.errepar.com/login/api",
    customers_and_products_api:
      "https://accounts.errepar.com/customers-and-products-api/api",
    e_auth: "https://accounts.errepar.com/eauth/eAuth",
    e_auth_url_JOB:
      "https://accounts.errepar.com/eauth/auth/job/getJobCredentialsEAuth",
    e_auth_generate_jwt3:
      "https://accounts.errepar.com/eauth/eauth/auth/generateJwt3",
    e_auth_notify_user_CAC:
      "https://accounts.errepar.com/eauth/eAuth/authCAC/notifyLoginUserEAuthCAC",
    e_auth_get_user_CAC:
      "https://accounts.errepar.com/eauth/auth/getUserCAC/verifyUserCognito",
    e_auth_redirect_auth:
      "https://accounts.errepar.com/eauth/auth/redirectAuth",
    e_auth_set_password: "https://accounts.errepar.com/eauth/eAuth/setPassword",
    invite_api: "/invite-api/api/invite",
    user_legacy_api: "https://accounts.errepar.com/user-legacy-api",
    eventslog_push:
      "https://accounts.errepar.com/eventslog-push/api/eventsLogPush",
    subscribers: "https://accounts.errepar.com/subscribers/api",
    suborganizations:
      "https://accounts.errepar.com/suborganization-api/api/suborganization",
    storage:
      "https://sse.miestudio.ar/mi-estudio/development/storage-api/api/storage",
    fileExtend: "/file-extension/api/fileExtension",
    e_authz: "/syserrepar/e-authz-api/api",
    e_auth_client_id: "7d8ja3us768tc6u5opj4n56coa",
    miestudio_user_registration:
      "https://miestudio.ar/user-registration-api/api",
    global_notification:
      "https://api.errepar.com/globalnotification/api/globalnotification",
    version_enviroments:
      "https://api.errepar.com/syserrepar/rtenvironments/api",
    sessions: "https://accounts.errepar.com/sessions/api/esession",
    declarations:
      "https://api.errepar.com/syserrepar/entitylegaldeclarations/api/entityLegalDeclarations",
    legal_communications:
      "https://api.errepar.com/syserrepar/legal-communications/v1",
    logout: "https://accounts.errepar.com/?logout=1&v=1",
    firmsCustomers:
      "https://miestudio.ar/syserrepar/business-services/erp/customersentities/firms-customers-api/api/firmscustomers",
    me: "https://miestudio.ar",
    afip_api: "https://miestudio.ar/afip-api/api",
    xslComposer:
      'https://api.errepar.com/syserrepar/xlscomposerapi/api'
  },
  uat: {
    base: "https://uat.miestudio.ar/syserrepar",
    storage:
      "https://sse.uat.miestudio.ar/syserrepar/businessservices/documentmanager/bulkstorage/bulk-storage-services/api/storage",
    fileExtend:
      "/bussinnessservices/security/file-extension-api/api/fileExtension",
    suborganizations:
      "https://uat.miestudio.ar/syserrepar/bussinnessservices/security/suborganization-api/api/suborganization",
    login: "https://accounts.uat.errepar.com/?appCode=CGI",
    localLogin:
      "https://accounts.uat.errepar.com/?urlRedirect=https://localhost:3000&appCode=CGI",
    organization:
      "/businessservices/organization/organization-services/api/organization",
    login_account: "https://accounts.uat.errepar.com/login/api",
    customers_and_products_api:
      "https://accounts.uat.errepar.com/syserrepar/business-services/crm/customers-and-products-api/api",
    e_auth: "/syserrepar/integration/authenticationandauthorization/e-auth-api",
    invite_api: "/invite-api/api/invite",
    user_legacy_api: "https://uat.miestudio.ar/syserrepar/user-legacy-api",
    eventslog_push: "https://uat.miestudio.ar/eventslog-push/api/eventsLogPush",
    subscribers: "https://accounts.uat.errepar.com/subscribers/api",
    e_auth_url_JOB:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/job/getJobCredentialsEAuth",
    e_authz: "/integration/authenticationandauthorization/e-authz-api/api",
    e_auth_notify_user_CAC:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/authCAC/notifyLoginUserEAuthCAC",
    e_auth_get_user_CAC:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/getUserCAC/verifyUserCognito",
    e_auth_redirect_auth:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/auth/redirectAuth",
    e_auth_set_password:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/eAuth/setPassword",
    e_auth_generate_jwt3:
      "https://accounts.uat.errepar.com/syserrepar/integration/authenticationandauthorization/e-auth-api/eauth/auth/generateJwt3",
    e_auth_client_id: "6dmg2a99r4cr702f5ulmfgorqu",
    miestudio_user_registration:
      "https://uat.miestudio.ar/syserrepar/business-services/erp/commercialproducts/miestudio-user-registration-api/api",
    version_enviroments:
      "https://api.uat.errepar.com/syserrepar/rtenvironments/api",
    sessions: "https://accounts.uat.errepar.com/sessions/api/esession",
    declarations:
      "https://api.uat.errepar.com/syserrepar/entitylegaldeclarations/api/entityLegalDeclarations",
    global_notification:
      "https://api.uat.errepar.com/globalnotification/api/globalnotification",
    legal_communications: "https://api.uat.errepar.com/legal-communications/v1",
    logout: "https://accounts.uat.errepar.com/?logout=1&v=1",
    firmsCustomers:
      "https://uat.miestudio.ar/syserrepar/business-services/erp/customersentities/firms-customers-api/api/firmscustomers",
    me: "https://sueldos.uat.miestudio.ar",
    afip_api:
      "https://uat.miestudio.ar/syserrepar/business-services/governmentandregulatoryagencies/argentina/afip-api/api",
    xslComposer:
      'https://api.uat.errepar.com/syserrepar/xlscomposerapi/api'
  },
}
function getEnviromentLibrary() {
  const enviromentNew = parser.getEnvironment()
  switch (enviromentNew) {
    case "QA":
      return enviromentsLibrary.qa
    case "DEV":
      return enviromentsLibrary.dev
    case "PROD":
      return enviromentsLibrary.prod
    case "UAT":
      return enviromentsLibrary.uat
    default:
      return null
  }
}

// ADD NEW LINKS HERE IN GETURL CASE
class LibraryClass {
  constructor() {
    if (LibraryClass.instance) {
      return LibraryClass.instance
    }
    Object.freeze(this)
    LibraryClass.instance = this
  }

  getBaseAPIUrl(action) {
    switch (action) {
      case "organization":
        return getEnviromentLibrary().base + getEnviromentLibrary().organization
      case "login_account":
        return getEnviromentLibrary().login_account
      case "fileExtend":
        return getEnviromentLibrary().base + getEnviromentLibrary().fileExtend
      case "suborganizations":
        return getEnviromentLibrary().suborganizations
      case "storage":
        return getEnviromentLibrary().storage
      case "login":
        return getEnviromentLibrary().login
      case "localLogin":
        return getEnviromentLibrary().localLogin
      case "generateJwt3":
        return getEnviromentLibrary().e_auth_generate_jwt3
      case "e_auth_notify_user_CAC":
        return getEnviromentLibrary().e_auth_notify_user_CAC
      case "e_authz":
        return getEnviromentLibrary().base + getEnviromentLibrary().e_authz
      case "e_auth_get_user_CAC":
        return getEnviromentLibrary().e_auth_get_user_CAC
      case "e_auth_redirect_auth":
        return getEnviromentLibrary().e_auth_redirect_auth
      case "e_auth_url_JOB":
        return getEnviromentLibrary().e_auth_url_JOB
      case "e_auth_set_password":
        return getEnviromentLibrary().e_auth_set_password
      case "e_auth_client_id":
        return getEnviromentLibrary().e_auth_client_id
      case "miestudio_user_registration":
        return getEnviromentLibrary().miestudio_user_registration
      case "customers_and_products_api":
        return getEnviromentLibrary().customers_and_products_api
      case "me":
        return getEnviromentLibrary().me
      case "e_auth":
        return getEnviromentLibrary().e_auth
      case "invite_api":
        return getEnviromentLibrary().base + getEnviromentLibrary().invite_api
      case "user_legacy_api":
        return getEnviromentLibrary().user_legacy_api
      case "eventslog_push":
        return getEnviromentLibrary().eventslog_push
      case "subscribers":
        return getEnviromentLibrary().subscribers
      case "global_notification":
        return getEnviromentLibrary().global_notification
      case "version_enviroments":
        return getEnviromentLibrary().version_enviroments
      case "sessions":
        return getEnviromentLibrary().sessions
      case "declarations":
        return getEnviromentLibrary().declarations
      case "legal_communications":
        return getEnviromentLibrary().legal_communications
      case "logout":
        return getEnviromentLibrary().logout
      case "firmsCustomers":
        return getEnviromentLibrary().firmsCustomers
      case "afip_api":
        return getEnviromentLibrary().afip_api
      case 'xslComposer':
        return getEnviromentLibrary().xslComposer
      default:
        return null
    }
  }
}
const library = new LibraryClass()

export default library
